import { service } from '@ember/service';

import type { RecordData, RequestError, Service } from 'webapp-types';
import { ModelName } from 'webapp/enums/enums';

import ReportsArchivePopupResendComponent from 'webapp/components/reports/archive/popup-resend';

import ReportDelivery from 'webapp/models-custom/report-delivery';
import type ReportDeliveryRecord from 'webapp/models/report-delivery';

import ModelManagerForStoreService from 'webapp/services/model-manager/for-store';

export default class ModelManagerReportDeliveriesService extends ModelManagerForStoreService<
	ReportDeliveryRecord,
	ReportDelivery
> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;
	@service('popup') declare popupService: Service.Popup;
	@service('account') declare accountService: Service.Account;

	resend(reportDelivery: ReportDelivery): void {
		if (this.accountService.handleDemo()) {
			return;
		}

		const popup = this.popupService.createModal(ReportsArchivePopupResendComponent, {
			popupClass: 'popup-type-report-resend title-bigger',
		});
		popup.open({ model: reportDelivery });
	}

	delete(reportDelivery: ReportDelivery): Promise<void> {
		if (this.accountService.handleDemo()) {
			return Promise.reject();
		}

		return new Promise((resolve, reject) => {
			const layer = this.infolayerService.loading('Deleting archive...');

			this.requestService
				.api('DELETE', `/report-deliveries/${reportDelivery.id}`)
				.then(
					() => {
						layer.ok('Archive has been deleted.');
						resolve();
					},
					(errorData: RequestError) => {
						layer.close();
						reject();
						throw errorData;
					},
				)
				.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
		});
	}

	// ------ Requests ------

	_reportDeliveriesRequested = false;
	_reportDeliveriesRequestPromise: Promise<void> | null = null;
	requestReportDeliveries(): Promise<void> {
		const variablePrefix = 'reportDeliveries';
		return this.requestService.dataRequestOnce<typeof variablePrefix>(
			this,
			variablePrefix,
			() => {
				// const testData = window.dbx_mock['GET /d/reports/deliveries'];
				// return Promise.resolve(testData);

				return this.requestService.api<RecordData.Payload>('GET', '/reports/deliveries');
			},
		);
	}

	// ------ For-store ------

	modelName = ModelName.REPORT_DELIVERY;
	override modelTitle = 'report archive';

	createModel(model: ReportDeliveryRecord): ReportDelivery {
		return new ReportDelivery({ model });
	}
}

declare module '@ember/service' {
	interface Registry {
		'model-manager/report-deliveries': ModelManagerReportDeliveriesService;
	}
}
